
import {UIGameMapCityWallController} from '../../../../shared/scripts/ui_game/ui_game_map/UIGameMapCityWallController'

export class UIMGameMapCityWallController extends UIGameMapCityWallController {
}
